export default __webpack_public_path__ + "static/media/logo_seraphim-01.dd64b32f.png";